// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"PrivacyPolicy_componentStyle__9EMEH"};